import type { ReactNode } from "react";
import type { SupportedCurrencyCode } from "@repo/api-schema";
import { formatMoney } from "../lib/money";

interface MoneyAmountProps {
  /** Amount in the smallest currency unit. */
  minor: number;
  currency: SupportedCurrencyCode;
  className?: string;
}

export function MoneyAmount({
  minor,
  currency,
  className = "",
}: MoneyAmountProps): ReactNode {
  return <span className={className}>{formatMoney(minor, currency)}</span>;
}
